import React, { useState } from "react";
import { Drawer, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ChatBot from "Samarth Module/pages/chatBot/chatBot";

export default function SamarthAIDrawer({ open, onClose }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleExpand = () => {
    setIsExpanded(true);
  };
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      BackdropProps={{
        invisible: true,
      }}
      PaperProps={{
        sx: {
          width: {
            xs: "100%",
            md: isExpanded ? "96%" : "48%",
            lg: isExpanded ? "96%" : "48%",
          },
          height: "calc(100vh - 50px)",
          top: "auto",
          bottom: 0,
          p: 2,
          backdropFilter: "blur(100.21739196777344px)",
          overflowX: "hidden",
          boxShadow: "0px 0px 20px 0px #0000001F",
        },
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        paddingLeft="24px"
      >
        <Typography fontWeight={600} fontSize={18}>
          Samarth AI
        </Typography>

        <IconButton onClick={onClose}>
          <CloseIcon sx={{ color: "#0066CC" }} />
        </IconButton>
      </Box>

      <ChatBot isExpand={open} onExpand={handleExpand} />
    </Drawer>
  );
}
